import { yup } from '@framework/validation/initYup.ts';
import { CiComputedBinaryGear } from '../../../../../ui/icons-custom/IconsCustom.tsx';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getDynamicWidgetReference } from '../../../../expressions/references/builder/getDynamicWidgetReference.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema.ts';
import { type IComputedBooleanWidget } from '../IComputedWidget.ts';
import { ComputedBooleanConfigComponent } from './ComputedBooleanConfigComponent.tsx';
import { ComputedBooleanWidgetComponent } from './ComputedBooleanWidgetComponent.tsx';
import { ComputedBooleanWidgetPreview } from './ComputedBooleanWidgetPreview.tsx';
import { computedBooleanConfigSchema } from './computedBooleanConfigSchema.ts';
import { setComputedBooleanTransform } from './setComputedBooleanTransform.ts';

export const ComputedBooleanWidgetType: IWidgetType<IComputedBooleanWidget> = {
  type: WidgetType.ComputedBoolean,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  hasValue: true,
  getReference: getDynamicWidgetReference(Datatype.Boolean),
  name: 'Condizione Calcolata',
  icon: <CiComputedBinaryGear />,
  rules: [],
  formComponent: ComputedBooleanWidgetComponent,
  createFormSchema: ({ widget, parentScope }) => {
    return createCommonFormSchema(
      setComputedBooleanTransform(
        widget,
        parentScope,
        yup.boolean().notRequired(),
      ),
      widget,
    );
  },
  configComponent: ComputedBooleanConfigComponent,
  configValidator: computedBooleanConfigSchema,
  previewComponent: ComputedBooleanWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
    text: tran.rte(),
  }),
  alwaysEnabled: true,
  aliases: ['bool', 'boolean'],
};
